import { Link } from "@tanstack/react-router";
import logo from "@/assets/crs-logo-white.webp";
import { SITE } from "@/lib/site";

export function DampSurveyFooter() {
  return (
    <footer className="bg-primary text-primary-foreground mt-16">
      <div className="container-page py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img
            src={logo}
            alt="CRS Energy"
            width={900}
            height={345}
            className="h-9 w-auto"
            decoding="async"
          />
          <p className="text-xs text-primary-foreground/70">
            © {new Date().getFullYear()} {SITE.legalName}. All rights reserved.
          </p>
        </div>
        <nav aria-label="Legal" className="flex items-center gap-5 text-sm">
          <Link to="/privacy" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Privacy
          </Link>
          <Link to="/data-protection" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Data Protection
          </Link>
          <Link to="/contact" className="text-primary-foreground/85 hover:text-primary-foreground transition-colors">
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
